/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as HealthzRouteImport } from './routes/healthz'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as AuthDashboardRouteImport } from './routes/_auth._dashboard'
import { Route as LoginIndexRouteImport } from './routes/login.index'
import { Route as AuthDashboardTenantRouteRouteImport } from './routes/_auth/_dashboard/$tenant.route'
import { Route as AppTenantIndexRouteImport } from './routes/app/$tenant/index'
import { Route as AuthDashboardTenantIndexRouteImport } from './routes/_auth/_dashboard/$tenant.index'
import { Route as AuthDashboardProfileIndexRouteImport } from './routes/_auth/_dashboard/profile/index'
import { Route as AuthDashboardTenantVenuesVenueIdRouteRouteImport } from './routes/_auth/_dashboard/$tenant.venues.$venueId/route'
import { Route as AuthDashboardTenantVenuesVenueIdIndexRouteImport } from './routes/_auth/_dashboard/$tenant.venues.$venueId/index'
import { Route as AuthDashboardTenantVenuesVenueIdEmployeeCentreRouteImport } from './routes/_auth/_dashboard/$tenant.venues.$venueId/employee-centre'
import { Route as AuthDashboardTenantVenuesVenueIdEposRouteRouteImport } from './routes/_auth/_dashboard/$tenant.venues.$venueId/epos/route'
import { Route as AuthDashboardTenantVenuesVenueIdEposIndexRouteImport } from './routes/_auth/_dashboard/$tenant.venues.$venueId/epos/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthzRoute = HealthzRouteImport.update({
  id: '/healthz',
  path: '/healthz',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => AuthRoute,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthDashboardTenantRouteRoute =
  AuthDashboardTenantRouteRouteImport.update({
    id: '/$tenant',
    path: '/$tenant',
    getParentRoute: () => AuthDashboardRoute,
  } as any)
const AppTenantIndexRoute = AppTenantIndexRouteImport.update({
  id: '/app/$tenant/',
  path: '/app/$tenant/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthDashboardTenantIndexRoute =
  AuthDashboardTenantIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthDashboardTenantRouteRoute,
  } as any)
const AuthDashboardProfileIndexRoute =
  AuthDashboardProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AuthDashboardRoute,
  } as any)
const AuthDashboardTenantVenuesVenueIdRouteRoute =
  AuthDashboardTenantVenuesVenueIdRouteRouteImport.update({
    id: '/venues/$venueId',
    path: '/venues/$venueId',
    getParentRoute: () => AuthDashboardTenantRouteRoute,
  } as any)
const AuthDashboardTenantVenuesVenueIdIndexRoute =
  AuthDashboardTenantVenuesVenueIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthDashboardTenantVenuesVenueIdRouteRoute,
  } as any)
const AuthDashboardTenantVenuesVenueIdEmployeeCentreRoute =
  AuthDashboardTenantVenuesVenueIdEmployeeCentreRouteImport.update({
    id: '/employee-centre',
    path: '/employee-centre',
    getParentRoute: () => AuthDashboardTenantVenuesVenueIdRouteRoute,
  } as any)
const AuthDashboardTenantVenuesVenueIdEposRouteRoute =
  AuthDashboardTenantVenuesVenueIdEposRouteRouteImport.update({
    id: '/epos',
    path: '/epos',
    getParentRoute: () => AuthDashboardTenantVenuesVenueIdRouteRoute,
  } as any)
const AuthDashboardTenantVenuesVenueIdEposIndexRoute =
  AuthDashboardTenantVenuesVenueIdEposIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthDashboardTenantVenuesVenueIdEposRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/healthz': typeof HealthzRoute
  '/logout': typeof LogoutRoute
  '/login/': typeof LoginIndexRoute
  '/$tenant': typeof AuthDashboardTenantRouteRouteWithChildren
  '/app/$tenant/': typeof AppTenantIndexRoute
  '/$tenant/': typeof AuthDashboardTenantIndexRoute
  '/profile/': typeof AuthDashboardProfileIndexRoute
  '/$tenant/venues/$venueId': typeof AuthDashboardTenantVenuesVenueIdRouteRouteWithChildren
  '/$tenant/venues/$venueId/epos': typeof AuthDashboardTenantVenuesVenueIdEposRouteRouteWithChildren
  '/$tenant/venues/$venueId/employee-centre': typeof AuthDashboardTenantVenuesVenueIdEmployeeCentreRoute
  '/$tenant/venues/$venueId/': typeof AuthDashboardTenantVenuesVenueIdIndexRoute
  '/$tenant/venues/$venueId/epos/': typeof AuthDashboardTenantVenuesVenueIdEposIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/healthz': typeof HealthzRoute
  '/logout': typeof LogoutRoute
  '/login': typeof LoginIndexRoute
  '/app/$tenant': typeof AppTenantIndexRoute
  '/$tenant': typeof AuthDashboardTenantIndexRoute
  '/profile': typeof AuthDashboardProfileIndexRoute
  '/$tenant/venues/$venueId/employee-centre': typeof AuthDashboardTenantVenuesVenueIdEmployeeCentreRoute
  '/$tenant/venues/$venueId': typeof AuthDashboardTenantVenuesVenueIdIndexRoute
  '/$tenant/venues/$venueId/epos': typeof AuthDashboardTenantVenuesVenueIdEposIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/healthz': typeof HealthzRoute
  '/logout': typeof LogoutRoute
  '/_auth/_dashboard': typeof AuthDashboardRouteWithChildren
  '/login/': typeof LoginIndexRoute
  '/_auth/_dashboard/$tenant': typeof AuthDashboardTenantRouteRouteWithChildren
  '/app/$tenant/': typeof AppTenantIndexRoute
  '/_auth/_dashboard/$tenant/': typeof AuthDashboardTenantIndexRoute
  '/_auth/_dashboard/profile/': typeof AuthDashboardProfileIndexRoute
  '/_auth/_dashboard/$tenant/venues/$venueId': typeof AuthDashboardTenantVenuesVenueIdRouteRouteWithChildren
  '/_auth/_dashboard/$tenant/venues/$venueId/epos': typeof AuthDashboardTenantVenuesVenueIdEposRouteRouteWithChildren
  '/_auth/_dashboard/$tenant/venues/$venueId/employee-centre': typeof AuthDashboardTenantVenuesVenueIdEmployeeCentreRoute
  '/_auth/_dashboard/$tenant/venues/$venueId/': typeof AuthDashboardTenantVenuesVenueIdIndexRoute
  '/_auth/_dashboard/$tenant/venues/$venueId/epos/': typeof AuthDashboardTenantVenuesVenueIdEposIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/healthz'
    | '/logout'
    | '/login/'
    | '/$tenant'
    | '/app/$tenant/'
    | '/$tenant/'
    | '/profile/'
    | '/$tenant/venues/$venueId'
    | '/$tenant/venues/$venueId/epos'
    | '/$tenant/venues/$venueId/employee-centre'
    | '/$tenant/venues/$venueId/'
    | '/$tenant/venues/$venueId/epos/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/healthz'
    | '/logout'
    | '/login'
    | '/app/$tenant'
    | '/$tenant'
    | '/profile'
    | '/$tenant/venues/$venueId/employee-centre'
    | '/$tenant/venues/$venueId'
    | '/$tenant/venues/$venueId/epos'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/healthz'
    | '/logout'
    | '/_auth/_dashboard'
    | '/login/'
    | '/_auth/_dashboard/$tenant'
    | '/app/$tenant/'
    | '/_auth/_dashboard/$tenant/'
    | '/_auth/_dashboard/profile/'
    | '/_auth/_dashboard/$tenant/venues/$venueId'
    | '/_auth/_dashboard/$tenant/venues/$venueId/epos'
    | '/_auth/_dashboard/$tenant/venues/$venueId/employee-centre'
    | '/_auth/_dashboard/$tenant/venues/$venueId/'
    | '/_auth/_dashboard/$tenant/venues/$venueId/epos/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  HealthzRoute: typeof HealthzRoute
  LogoutRoute: typeof LogoutRoute
  LoginIndexRoute: typeof LoginIndexRoute
  AppTenantIndexRoute: typeof AppTenantIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/healthz': {
      id: '/healthz'
      path: '/healthz'
      fullPath: '/healthz'
      preLoaderRoute: typeof HealthzRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_dashboard': {
      id: '/_auth/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_dashboard/$tenant': {
      id: '/_auth/_dashboard/$tenant'
      path: '/$tenant'
      fullPath: '/$tenant'
      preLoaderRoute: typeof AuthDashboardTenantRouteRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/app/$tenant/': {
      id: '/app/$tenant/'
      path: '/app/$tenant'
      fullPath: '/app/$tenant/'
      preLoaderRoute: typeof AppTenantIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_dashboard/$tenant/': {
      id: '/_auth/_dashboard/$tenant/'
      path: '/'
      fullPath: '/$tenant/'
      preLoaderRoute: typeof AuthDashboardTenantIndexRouteImport
      parentRoute: typeof AuthDashboardTenantRouteRoute
    }
    '/_auth/_dashboard/profile/': {
      id: '/_auth/_dashboard/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthDashboardProfileIndexRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/$tenant/venues/$venueId': {
      id: '/_auth/_dashboard/$tenant/venues/$venueId'
      path: '/venues/$venueId'
      fullPath: '/$tenant/venues/$venueId'
      preLoaderRoute: typeof AuthDashboardTenantVenuesVenueIdRouteRouteImport
      parentRoute: typeof AuthDashboardTenantRouteRoute
    }
    '/_auth/_dashboard/$tenant/venues/$venueId/': {
      id: '/_auth/_dashboard/$tenant/venues/$venueId/'
      path: '/'
      fullPath: '/$tenant/venues/$venueId/'
      preLoaderRoute: typeof AuthDashboardTenantVenuesVenueIdIndexRouteImport
      parentRoute: typeof AuthDashboardTenantVenuesVenueIdRouteRoute
    }
    '/_auth/_dashboard/$tenant/venues/$venueId/employee-centre': {
      id: '/_auth/_dashboard/$tenant/venues/$venueId/employee-centre'
      path: '/employee-centre'
      fullPath: '/$tenant/venues/$venueId/employee-centre'
      preLoaderRoute: typeof AuthDashboardTenantVenuesVenueIdEmployeeCentreRouteImport
      parentRoute: typeof AuthDashboardTenantVenuesVenueIdRouteRoute
    }
    '/_auth/_dashboard/$tenant/venues/$venueId/epos': {
      id: '/_auth/_dashboard/$tenant/venues/$venueId/epos'
      path: '/epos'
      fullPath: '/$tenant/venues/$venueId/epos'
      preLoaderRoute: typeof AuthDashboardTenantVenuesVenueIdEposRouteRouteImport
      parentRoute: typeof AuthDashboardTenantVenuesVenueIdRouteRoute
    }
    '/_auth/_dashboard/$tenant/venues/$venueId/epos/': {
      id: '/_auth/_dashboard/$tenant/venues/$venueId/epos/'
      path: '/'
      fullPath: '/$tenant/venues/$venueId/epos/'
      preLoaderRoute: typeof AuthDashboardTenantVenuesVenueIdEposIndexRouteImport
      parentRoute: typeof AuthDashboardTenantVenuesVenueIdEposRouteRoute
    }
  }
}

interface AuthDashboardTenantVenuesVenueIdEposRouteRouteChildren {
  AuthDashboardTenantVenuesVenueIdEposIndexRoute: typeof AuthDashboardTenantVenuesVenueIdEposIndexRoute
}

const AuthDashboardTenantVenuesVenueIdEposRouteRouteChildren: AuthDashboardTenantVenuesVenueIdEposRouteRouteChildren =
  {
    AuthDashboardTenantVenuesVenueIdEposIndexRoute:
      AuthDashboardTenantVenuesVenueIdEposIndexRoute,
  }

const AuthDashboardTenantVenuesVenueIdEposRouteRouteWithChildren =
  AuthDashboardTenantVenuesVenueIdEposRouteRoute._addFileChildren(
    AuthDashboardTenantVenuesVenueIdEposRouteRouteChildren,
  )

interface AuthDashboardTenantVenuesVenueIdRouteRouteChildren {
  AuthDashboardTenantVenuesVenueIdEposRouteRoute: typeof AuthDashboardTenantVenuesVenueIdEposRouteRouteWithChildren
  AuthDashboardTenantVenuesVenueIdEmployeeCentreRoute: typeof AuthDashboardTenantVenuesVenueIdEmployeeCentreRoute
  AuthDashboardTenantVenuesVenueIdIndexRoute: typeof AuthDashboardTenantVenuesVenueIdIndexRoute
}

const AuthDashboardTenantVenuesVenueIdRouteRouteChildren: AuthDashboardTenantVenuesVenueIdRouteRouteChildren =
  {
    AuthDashboardTenantVenuesVenueIdEposRouteRoute:
      AuthDashboardTenantVenuesVenueIdEposRouteRouteWithChildren,
    AuthDashboardTenantVenuesVenueIdEmployeeCentreRoute:
      AuthDashboardTenantVenuesVenueIdEmployeeCentreRoute,
    AuthDashboardTenantVenuesVenueIdIndexRoute:
      AuthDashboardTenantVenuesVenueIdIndexRoute,
  }

const AuthDashboardTenantVenuesVenueIdRouteRouteWithChildren =
  AuthDashboardTenantVenuesVenueIdRouteRoute._addFileChildren(
    AuthDashboardTenantVenuesVenueIdRouteRouteChildren,
  )

interface AuthDashboardTenantRouteRouteChildren {
  AuthDashboardTenantIndexRoute: typeof AuthDashboardTenantIndexRoute
  AuthDashboardTenantVenuesVenueIdRouteRoute: typeof AuthDashboardTenantVenuesVenueIdRouteRouteWithChildren
}

const AuthDashboardTenantRouteRouteChildren: AuthDashboardTenantRouteRouteChildren =
  {
    AuthDashboardTenantIndexRoute: AuthDashboardTenantIndexRoute,
    AuthDashboardTenantVenuesVenueIdRouteRoute:
      AuthDashboardTenantVenuesVenueIdRouteRouteWithChildren,
  }

const AuthDashboardTenantRouteRouteWithChildren =
  AuthDashboardTenantRouteRoute._addFileChildren(
    AuthDashboardTenantRouteRouteChildren,
  )

interface AuthDashboardRouteChildren {
  AuthDashboardTenantRouteRoute: typeof AuthDashboardTenantRouteRouteWithChildren
  AuthDashboardProfileIndexRoute: typeof AuthDashboardProfileIndexRoute
}

const AuthDashboardRouteChildren: AuthDashboardRouteChildren = {
  AuthDashboardTenantRouteRoute: AuthDashboardTenantRouteRouteWithChildren,
  AuthDashboardProfileIndexRoute: AuthDashboardProfileIndexRoute,
}

const AuthDashboardRouteWithChildren = AuthDashboardRoute._addFileChildren(
  AuthDashboardRouteChildren,
)

interface AuthRouteChildren {
  AuthDashboardRoute: typeof AuthDashboardRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthDashboardRoute: AuthDashboardRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  HealthzRoute: HealthzRoute,
  LogoutRoute: LogoutRoute,
  LoginIndexRoute: LoginIndexRoute,
  AppTenantIndexRoute: AppTenantIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
